import { useCallback, useEffect, useRef, useState } from 'react';

const useCursorList = (read, failed_text, on_error, to_error) => {
  const [state, setState] = useState({ status: 'loading', rows: [], next: null, meta: {} });
  const [more_busy, setMoreBusy] = useState(false);
  const [error, setError] = useState({ kind: '', text: '' });
  const seq = useRef(0);

  const run = useCallback(
    (cursor) => {
      seq.current += 1;
      const mine = seq.current;
      if (cursor) setMoreBusy(true);
      else setState((s) => ({ ...s, status: 'loading' }));
      read(cursor)
        .then((page) => {
          if (mine !== seq.current) return;
          setMoreBusy(false);
          setError({ kind: '', text: '' });
          setState((s) => ({
            status: 'ready',
            rows: cursor ? s.rows.concat(page.rows) : page.rows,
            next: page.next,
            meta: page.meta || {}
          }));
        })
        .catch((e) => {
          if (mine !== seq.current) return;
          const v = to_error(e, failed_text);
          if (v.kind === 'auth') on_error(e, failed_text);
          setMoreBusy(false);
          setError(v);
          if (!cursor) setState({ status: 'error', rows: [], next: null, meta: {} });
        });
    },
    [read, failed_text, on_error, to_error]
  );

  useEffect(() => {
    run(null);
  }, [run]);

  return {
    ...state,
    more_busy,
    error,
    reload: () => run(null),
    load_more: () => run(state.next)
  };
};

export default useCursorList;
